/* BB 26.09.2026
   1) Produktseite: eigener Hinweis "X % unter UVP", immer abgerundet und passend zur gewaehlten Variante.
      Das alte "(Du sparst X%)" des Themes rundet auf und wird per CSS ausgeblendet.
   2) Screenreader: "Regulärer Preis" vor dem Streichpreis wird zu "Unverbindliche Preisempfehlung".
   3) Kategorie-Kopf: Unterkategorie-Buttons bekommen einen Rand-Verlauf, solange man seitlich wischen kann. */
(function () {
  function uvpVorlesen() {
    document.querySelectorAll('.product-meta__price-list-container .price--compare .visually-hidden, .product-item-meta__price-list-container .price--compare .visually-hidden').forEach(function (s) {
      if (s.textContent !== 'Unverbindliche Preisempfehlung') s.textContent = 'Unverbindliche Preisempfehlung';
    });
  }

  function chipsVerlauf() {
    document.querySelectorAll('.bbk__chips').forEach(function (liste) {
      function pruefen() {
        var ende = liste.scrollLeft + liste.clientWidth >= liste.scrollWidth - 4;
        liste.classList.toggle('bbk-ende', ende);
      }
      if (!liste.dataset.bbVerlauf) {
        liste.dataset.bbVerlauf = '1';
        liste.addEventListener('scroll', pruefen, { passive: true });
        window.addEventListener('resize', pruefen);
      }
      pruefen();
    });
  }

  var produkt = null;
  function aktuelleVariante() {
    if (!produkt) return null;
    var feld = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = feld ? String(feld.value) : '';
    var treffer = null;
    produkt.variants.forEach(function (v) { if (String(v.id) === id) treffer = v; });
    return treffer || produkt.variants[0];
  }
  function uvpHinweis() {
    var v = aktuelleVariante();
    if (!v) return;
    var text = '';
    if (v.compare_at_price && v.compare_at_price > v.price) {
      var p = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      if (p >= 1) text = p + ' % unter UVP';
    }
    document.querySelectorAll('.product-meta__price-list-container').forEach(function (box) {
      var el = box.querySelector(':scope > .bb-uvp-hinweis');
      if (!el) {
        el = document.createElement('span');
        el.className = 'bb-uvp-hinweis';
        box.appendChild(el);
      }
      if (el.textContent !== text) el.textContent = text;
      el.hidden = text === '';
    });
  }

  var geplant = false;
  function planen() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(function () {
      geplant = false;
      uvpVorlesen();
      uvpHinweis();
    });
  }

  function start() {
    uvpVorlesen();
    chipsVerlauf();
    if (/\/products\/[^/]+/.test(location.pathname)) {
      var handle = location.pathname.split('/products/')[1].split(/[/?#]/)[0];
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j) return;
          produkt = j;
          document.documentElement.classList.add('bb-uvp-aktiv');
          uvpHinweis();
          new MutationObserver(planen).observe(document.body, { childList: true, subtree: true, characterData: true });
          document.addEventListener('change', function () { setTimeout(planen, 60); });
        })
        .catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
